import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Home, HomeProps} from './Home';

export interface HomeSectionProps extends HomeProps {
  locale: string;
}

let manager = new I18nManager({locale: 'en-CA'});

function HomeSection(props: HomeSectionProps) {
  const {locale, ...restProps} = props;

  if (locale && locale !== 'en-CA') {
    manager = new I18nManager({locale});
  }

  return (
    <I18nContext.Provider value={manager}>
      <Home {...restProps} />
    </I18nContext.Provider>
  );
}

export default renderReact('Home', HomeSection);
